import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/step/StepSkeleton.less';

export interface StepSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
}

/**
 * Скелетон компонента шага.
 */
export const StepSkeleton = (props: StepSkeletonProps) => {
    const className = classNames(
        'stepSkeleton',
        windowTypeToClassName(props.windowType),
    );

    return <Skeleton className={className} visible animate />;
};
